import { Api } from "./Api.class";
const endpoint = "third_parties";
const thirdPartiesAPI = new Api(endpoint);
export default thirdPartiesAPI;
